<template>

  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10 align-self-center">
      <h2 class="mt-0">My Task</h2>
    </div>

  </div>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-lg-3 mb-1 pr-0 pl-1 tileheight">
        <div
          class="dash-widget cursor-pointer border-first"
          
        >
          <div class="row">
            <div class="col-12 text-left" @click="onPendingClick('Approval')"> 
              <span>
                <h4>Pending Approval</h4>
              </span>
              <h1 class="font-bold">{{ documentprocesscount.pendingApprovalCount }}</h1>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-1 pr-0 pl-1 tileheight">

        <div
          class="dash-widget cursor-pointer border-second"
         
        >
          <div class="row">
            <div class="col-12 text-left" @click="onPendingClick('Reviewer')">
              <span>
                <h4>Pending Review</h4>
              </span>
              <h1 class="font-bold">{{ documentprocesscount.pendingReviewCount }}</h1>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-1 pr-0 pl-1 tileheight">

        <div
          class="dash-widget cursor-pointer border-third"
        >
          <div class="row">
            <div class="col-12 text-left" @click="onPendingClick('QC')">
              <span>
                <h4>Pending QC</h4>
              </span>
              <h1 class="font-bold">{{ documentprocesscount.pendingQCCount}}</h1>
            </div>
          </div>
        </div>
      </div>

<div class="col-lg-3 mb-1 pr-0 pl-1 tileheight">

        <div
          class="dash-widget cursor-pointer border-fifth"
        >
          <div class="row">
            <div class="col-12 text-left" @click="onPendingsignClick()">
              <span>
                <h4>Pending e-Sign</h4>
              </span>
              <h1 class="font-bold">{{documentsignstatuscount.sent}}</h1>
            </div>
            
          </div>
        </div>
      </div>

   <div class="ibox-content mb-1 px-4 py-2">
      <div class="form-group mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
           <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                <label class="mb-0"> {{ $t("navigations.document title") }}</label>
                <input v-model="searchFields.documentTitle" type="text" class="form-control my-md-2 my-lg-0" />
              </div>
              <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
                <label class="mb-0"> {{ $t("navigations.artifact name") }}</label>
                <input v-model="searchFields.artifactName" type="text" class="form-control my-md-2 my-lg-0" />
              </div>
          <span
            @click="OnSearchButtonClicked"
            class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
          >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 my-1 pl-1 pr-0">
        <div class="ibox-body">
          <div class="ibox-title d-flex justify-content-between style_2">
            <h5 class="my-0">Recently Uploaded Documents</h5>

          </div>
<div class="ibox-content tabledimentions">
  <div class="text-center" v-if="documentapprovalstatusbyidlist.length===0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else>
  <table class="table table-striped table-bordered dataTables ">
            <thead>
              <tr>
              <th
                @click="SortSelected('documentTitle')"
                :class="{
                sortAsc: SortProperty === 'documentTitle' && SortOrder,
                sortDesc: SortProperty === 'documentTitle' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Document Title
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
                     <th
                @click="SortSelected('name')"
                :class="{
                sortAsc: SortProperty === 'name' && SortOrder,
                sortDesc: SortProperty === 'name' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Document Name
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
               <th
                @click="SortSelected('siteCode',1)"
                :class="{
                sortAsc: SortProperty === 'siteCode' && SortOrder,
                sortDesc: SortProperty === 'siteCode' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                 Site Code 
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <th
                @click="SortSelected('artifactName')"
                :class="{
                sortAsc: SortProperty === 'artifactName' && SortOrder,
                sortDesc: SortProperty === 'artifactName' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Artifact Name
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <th
                @click="SortSelected('owner')"
                :class="{
                sortAsc: SortProperty === 'owner' && SortOrder,
                sortDesc: SortProperty === 'owner' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Owner
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <th
                @click="SortSelected('CreatedUserName')"
                :class="{
                sortAsc: SortProperty === 'CreatedUserName' && SortOrder,
                sortDesc: SortProperty === 'CreatedUserName' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Created By
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <th
                @click="SortSelected('CreatedAt')"
                :class="{
                sortAsc: SortProperty === 'CreatedAt' && SortOrder,
                sortDesc: SortProperty === 'CreatedAt' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Created Date
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <!-- <th
                @click="SortSelected('catagory')"
                :class="{
                sortAsc: SortProperty === 'catagory' && SortOrder,
                sortDesc: SortProperty === 'catagory' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Category
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th> -->
              <th
                @click="SortSelected('documentStatus')"
                :class="{
                sortAsc: SortProperty === 'documentStatus' && SortOrder,
                sortDesc: SortProperty === 'documentStatus' && !SortOrder,
                }"
              >
                <div class="d-flex flex-row justify-content-between">
                Document Status
                <span>
                  <i class="fa fa-long-arrow-up"></i>
                  <i class="fa fa-long-arrow-down"></i>
                </span>
                </div>
              </th>
              <th class="text-center">View</th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="documentapprovalstatus in documentapprovalstatusbyidlist" :key="documentapprovalstatus.id">
                <td class="wrap-text">{{ documentapprovalstatus.documentTitle }}</td>
                <td class="wrap-text">{{ documentapprovalstatus.name }}</td>
                 <td class="wrap-text">{{ documentapprovalstatus.siteCode }}</td>
                <td class="wrap-text">{{ documentapprovalstatus.artifactName }}</td>
                <td class="wrap-text">{{ documentapprovalstatus.owner }}</td>
                <td class="wrap-text">{{ documentapprovalstatus.documentVersions?.slice(-1)[0]?.createdUserName }}</td>
                <td class="wrap-text">
                  {{ documentapprovalstatus.documentVersions?.slice(-1)[0]?.createdAt
                              ?.replace('T', ' ')
                              .substring(0, 19) }}
                </td>
                <!-- <td class="text-center">{{ documentapprovalstatus.catagory }}</td> -->
                <td class="text-center">{{ documentapprovalstatus.documentVersions?.slice(-1)[0]?.versionStatus }}</td>
                    <td class="text-center">
                    <a
                      @click.prevent="
                      docuViewer(
                        documentapprovalstatus.id,
                        documentapprovalstatus.name,
                       (documentapprovalstatus.documentVersions || [])[documentapprovalstatus.documentVersions?.length - 1]?.version) 
                      
                      "
                      ><i class="fa fa-eye editicon"></i
                    ></a>
                    </td>



              </tr>
            </tbody>
          </table>
          </div>
</div>
 <!------ pagination -------->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                 
                <v-pagination
                    v-model="currentPageNumber"
                    :pages="totalLists"
                    active-color="#618bd7"
                    @update:modelValue="loadPage"
                  />
                </div>
              </div>
            </div>
          </div>
</div>
    </div>

    </div>
  </div>
  <customModal
   v-if="showpop == true"
   :containersm="true"
   :footerShow="true"
   @closeModal="ClosePendingList"
  >
   <template #title>
    {{ headingdata }}
   </template>
   <template #body>
    <div class="table-responsive mt-2 scrollable">
      <table class="table table-bordered table-sm" v-if="documentPopupstatusbyidlist.length > 0">
       <thead>
        <tr>
          <th>Document Title</th>
          <th>Artifact Name</th>
          <th>Created By</th>
          <th>View</th>
        </tr>
       </thead>
       <tbody>
        <tr v-for="item in documentPopupstatusbyidlist" :key="item.id">
          <td>{{ item.documentTitle }}</td>
          <td>{{ item.artifactName }}</td>
          <td>{{ item.CreatedUserName }}</td>
          <td class="tdtext">
            <a href="#" class="editicon"><i class="fa fa-eye" @click="viewDocumentDetails(item.id, 'active alerts', item.documentVersions[0].version)"></i></a>
           </td>
        </tr>
       </tbody>
      </table>
      <div v-else class="text-center py-3">
       No data found
      </div>
    </div>
   </template>
   <template #footer> </template>
  </customModal>
  <!-- sign model -->
  <customModal v-if="showsignpop == true" :containersm="true" :footerShow="true" @closeModal="Closesignpopup">
    <template #title>
      Pending e-Sign
    </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm" v-if="documentsignatureidlist.length > 0">
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Artifact Name</th>
              <th>Status</th>
              <th>Created By</th>
              <th>Sign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in documentsignatureidlist" :key="item.id">
              <td>{{ item.documentName }}</td>
              <td>{{ item.artifactName }}</td>
              <td>{{  datacorrected[item.status] }}</td>
              <td>{{ item.createdUserName }}</td>
              <td class="tdtext">
                <a href="#" class="editicon" v-if="item.status == 'sent'">
                  <img src="../../assets/img/icons/digital-signature.png" @click="gotodocumentsign(item.envelopeId, item.recipients[0].recipientEmail,item.recipients[0].recipientSignOrder)" width="15" class="" />
                  <!-- <i class="fa fa-eye"
                    @click="viewDocumentDetails(item.id, 'active alerts', item.documentVersions[0].version)">
                  </i> -->
                  </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-center py-3">
          No data found
        </div>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import customModal from "../customModal/customModal.vue";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
// let testarray= [];
export default {
  name: "formDashBoard",
  components: {
    VPagination,
    customModal
  },
 

  data() {
    return {
      showsignpop: false,
      sourcePage: "",
         source: '',
         officeurl: '',
        baseurl: process.env.VUE_APP_Service_URL,
        approvedStatus: "",
        qcStatus: "",
        reviewedStatus: "",
        documentTitle: "",
        owner: "",
        category: "",
        presentPage: "",
        headingdata: "",
        status: "",
        searchText: "",
        showpop: false,
        SortProperty: "CreatedAt",
        SortOrder: false,
        SortOrderInt: 1,
        documentprocesscount:{},
        documentsignstatuscount: {},
        documentapprovalstatusbyidlist:[],
        documentsignatureidlist:[],
        currentPageNumber: 1,
        totalLists: 0,
        documentPopupstatusbyidlist:[],
        pageSize: 10,
        Pageindex:1,
         searchFields: {
          artifactName:"",
          createdAt:"",
          documentTitle:""
        },
        searchField: {
          status:"",
          type:"",

        },
        Pagesize: 10,
          datacorrected:{
        "sent":"Pending",
        "created":"Awaiting",
        "completed":"Signed",
        

      }


      };
  },
   beforeRouteEnter(to, from, next) {
    const previousRouteName = from.name;
    console.log("previousRouteName", previousRouteName);
    if (previousRouteName == 'etmfdoc') {
      localStorage.setItem("setDocViewSource", "Approval")
    }
    if (previousRouteName == 'etmf' && localStorage.getItem("presentPage") != null) {
      localStorage.setItem("presentPage", "etmf")
    }
   if (previousRouteName == 'etmf' || previousRouteName == "signerslist") {
      localStorage.setItem("presentPage", "etmf")
    }
     {
      localStorage.setItem("presentPage", "etmf")
    }
    if (previousRouteName == 'folderDocLogin') {
      localStorage.setItem("presentPage", "folderDocLogin")
    }
    if (previousRouteName == 'etmfdoc') {
      localStorage.setItem("presentPage", "etmfdoc")
    }
    if (previousRouteName == 'folder') {
      localStorage.setItem("presentPage", "folder")
    }
    next((vm) => {
      vm.previousRouteName = previousRouteName;
    });
  },
   async mounted() {
        this.getdocumentprocesscount();
         this.sourcePage = await store.getters.getDocViewSource;
        this.getdocumentsignstatuscount();
        this.getdocumentapprovalstatusbyid();
    window.addEventListener("studyIdChanged", async (event) => {
       this.getdocumentprocesscount();
        this.getdocumentsignstatuscount();
        this.getdocumentapprovalstatusbyid();
    });
   
  },

  methods: {
    async gotodocumentsign(envelopeId, recipientEmail,recipientSignOrder) {
      store.dispatch('setSigningFrom', 'etmfuserdashboard')
      this.$router.push(`/signfrompopup/${envelopeId}/${recipientEmail}/${recipientSignOrder}`)
    },
    async Closesignpopup(){
      this.showsignpop = false;
      },
      async getdocumentapprovalstatusbyid(){
    let studyid = store.getters.getStudyIs;
     const idtoken = store.getters.getIdToken;
     await axios
            .get(
              `${this.baseurl}/etmf/document/getdocumentsbystudy?StudyId=${studyid}&Pageindex=${this.Pageindex}&Pagesize=${this.Pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrderInt}&userType=user&artifactName=${this.searchFields.artifactName}&createdAt=${this.searchFields.createdAt}&documentTitle=${this.searchFields.documentTitle}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {

              this.documentapprovalstatusbyidlist = res.data.entities;
              console.log("documentapprovalstatusbyidlist",this.documentapprovalstatusbyidlist);
              console.log("totalCount........",res.data.totalCount , "page size",this.Pagesize);
              this.totalLists = parseInt(res.data.totalCount / this.Pagesize);
                        if (res.data.totalCount % this.Pagesize != 0) {
                            this.totalLists = this.totalLists + 1;
                          }            })
            .catch((err) => {
    
              console.log("No data found!",err);
    
            })
   },
      async getdocumentPopupstatusbyid(){
    let studyid = store.getters.getStudyIs;
     const idtoken = store.getters.getIdToken;
     await axios
            .get(
              `${this.baseurl}/etmf/document/getdocumentsbystudy?StudyId=${studyid}&Pageindex=${this.Pageindex}&Pagesize=${this.Pagesize}&userType=user&type=${this.searchField.type}&status=${this.searchField.status}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {

              this.documentPopupstatusbyidlist = res.data.entities;
              console.log("documentPopupstatusbyidlist",this.documentPopupstatusbyidlist);
              console.log("totalCount........",res.data.totalCount , "page size",this.Pagesize);
              this.totalLists = parseInt(res.data.totalCount / this.Pagesize);
                        if (res.data.totalCount % this.Pagesize != 0) {
                            this.totalLists = this.totalLists + 1;
                          }            })
            .catch((err) => {
    
              console.log("No data found!",err);
    
            })
   },
   async onPendingClick(value){
     this.documentPopupstatusbyidlist = [];
      if (value == 'Approval') {
                this.searchField.type='Approval';
                this.headingdata = "Pending Approval";
                }
                else if (value == 'Reviewer') {
                  this.searchField.type='Reviewer';
                  this.headingdata = "Pending Review";
                  }
                  else if (value == 'QC') {
                    this.searchField.type='QC';
                    this.headingdata = "Pending QC";
                    }
           
            this.searchField.status='Pending';
            this.showpop = true;
            this.getdocumentPopupstatusbyid();
    },
    async onPendingsignClick() {
      this.documentsignatureidlist = [];

        this.searchFields.type = 'Signatures';


      this.searchFields.status = 'Pending';
      this.showsignpop = true;
      this.getdocumentsignPopupstatus();
    },
     async getdocumentsignPopupstatus() {
      let studyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getdocumentssignbystudy?studyId=${studyid}&pageindex=1&pagesize=1000&userType=user&status=sent`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {

              this.documentsignatureidlist = res.data.entities;
           })
            .catch((err) => {
    
              console.log("No data found!",err);
    
            })
   },
    ClosePendingList() {
            this.showpop = false;
        },
         async viewDocumentDetails(id, name, version) {
      this.$router.push(`/documentview/${id}/${version}`)
    },
     async OnSearchButtonClicked() {           
            this.currentPageNumber = 1;
            this.getdocumentapprovalstatusbyid();
        },
   async getdocumentprocesscount(){
    let studyid = store.getters.getStudyIs;
     const idtoken = store.getters.getIdToken;
     await axios
            .get(
              `${this.baseurl}/etmf/document/getdocumentprocesscount?StudyId=${studyid}&status=Pending&Type=user`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              this.documentprocesscount = res.data;
    
            })
            .catch((err) => {
    
              console.log("No data found!",err);
    
            })
   },
   
     async setdoc() {
      if (this.presentPage == 'folder' || this.presentPage == 'folderDocLogin' || this.presentPage == 'etmf' || this.presentPage == 'etmfdoc') {
        this.source = `${this.baseurl}/etmf/document/getdocument?documentId=${this.referenceId}`
      }
      else {
        this.source = `${this.fileuploadurl}/file/${this.referenceId}?versionid=${this.versionId}`;
      }
      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.source}`;
    },
      SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        // Same column clicked → toggle sort direction
        this.SortOrder = !this.SortOrder;
      } else {
        // New column clicked → reset to ascending
        this.SortProperty = sortProp;
        this.SortOrder = true;
      }

      this.SortOrderInt = this.SortOrder ? 0 : 1;
      this.pageindex = 1;
      this.currentPageNumber = 1;
      this.getdocumentapprovalstatusbyid();
    },
 async docuViewer(id, name, version) {
      this.$router.push(`/documentview/${id}/${version}`)
    },
   async getdocumentsignstatuscount(){
    let studyid = store.getters.getStudyIs;
     const idtoken = store.getters.getIdToken;
     await axios
            .get(
               `${this.baseurl}/etmf/document/getdocumentsignstatuscount?StudyId=${studyid}&Type=user`,
                {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
                }
            )
            .then((res) => {
              this.documentsignstatuscount = res.data;
    
            })
            .catch((err) => {
    
              console.log("No data found!",err);
    
            })
   },
   async loadPage(page) {
            this.currentPageNumber = page;
            this.Pageindex = page;
            this.getdocumentapprovalstatusbyid();
        },
  },
};
</script>

<style scoped>

.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.widgetmargin {
  margin-top: -13px !important;
}
.tabledimentions{
  height: 400px;
  overflow: auto;
}
.tileheight{
  min-height:100px
}
.border-first{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #f296ab;
}
.border-second{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #c0cb82;
}
.border-third{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #a6ddef;
}
.border-fourth{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #c5acf0;
}
.border-fifth{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #e77f9b;
}
.border-sixth{
  border-left-style: solid;
    border-left-width: 7px;
    border-color: #83d797;
}
</style>
